import { useSelector } from "react-redux";

export function usePermissions() {
  const permissions = useSelector((state) => state.user.permissions) || [];

  const permissionNames = permissions.map(p => p.abbreviation);

  const hasPermission = (permission) => {
    return permissionNames.includes(permission);
  };

  const hasAnyPermission = (checkPermissions) => {
    return checkPermissions.some(p => permissionNames.includes(p));
  };

  const hasAllPermissions = (checkPermissions) => {
    return checkPermissions.every(p => permissionNames.includes(p));
  };

  return { hasPermission, hasAnyPermission, hasAllPermissions };
}